var _style, _g, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E1CE2B;}\n\t.st1{fill:#EDBD2F;}\n\t.st2{fill:#D04090;}\n\t.st3{fill:#1668A5;}\n\t.st4{fill:#BA3C87;}\n\t.st5{fill:#106AA8;}\n\t.st6{fill:#AA7E4F;}\n\t.st7{fill:#C3955B;}\n\t.st8{fill:#12AEE5;}\n\t.st9{fill:#C9C9C8;}\n\t.st10{fill:#FFFFFF;}\n\t.st11{fill:none;stroke:#EDBD2F;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:#B2B1B4;}\n\t.st13{fill:#996E48;}\n\t.st14{fill:#F9DA62;}\n\t.st15{fill:#EDDB99;}\n\t.st16{fill:#EFD378;}\n\t.st17{fill:#126AA7;}\n\t.st18{fill:#E2D588;}\n\t.st19{fill:#FAFAFA;}\n\t.st20{clip-path:url(#SVGID_2_);}\n\t.st21{clip-path:url(#SVGID_4_);fill:#FFFFFF;}\n\t.st22{clip-path:url(#SVGID_6_);}\n\t.st23{clip-path:url(#SVGID_8_);fill:#D04090;}\n\t.st24{clip-path:url(#SVGID_10_);}\n\t.st25{clip-path:url(#SVGID_12_);fill:#00AABD;}\n\t.st26{clip-path:url(#SVGID_14_);}\n\t.st27{clip-path:url(#SVGID_16_);fill:#E1CE2B;}\n\t.st28{fill:#329866;}\n\t.st29{fill:#338958;}\n\t.st30{fill:#3AA36B;}\n\t.st31{clip-path:url(#SVGID_18_);}\n\t.st32{clip-path:url(#SVGID_20_);fill:#006597;}\n\t.st33{clip-path:url(#SVGID_22_);}\n\t.st34{clip-path:url(#SVGID_24_);fill:#D04090;}\n\t.st35{clip-path:url(#SVGID_26_);}\n\t.st36{clip-path:url(#SVGID_28_);fill:#00AABD;}\n\t.st37{clip-path:url(#SVGID_30_);}\n\t.st38{clip-path:url(#SVGID_32_);fill:#E1CE2B;}\n\t.st39{clip-path:url(#SVGID_34_);}\n\t.st40{clip-path:url(#SVGID_36_);fill:#006597;}\n\t.st41{clip-path:url(#SVGID_38_);}\n\t.st42{clip-path:url(#SVGID_40_);fill:#D04090;}\n\t.st43{clip-path:url(#SVGID_42_);}\n\t.st44{clip-path:url(#SVGID_44_);fill:#00AABD;}\n\t.st45{clip-path:url(#SVGID_46_);}\n\t.st46{clip-path:url(#SVGID_48_);fill:#E1CE2B;}\n\t.st47{clip-path:url(#SVGID_50_);}\n\t.st48{clip-path:url(#SVGID_52_);fill:#006597;}\n\t.st49{clip-path:url(#SVGID_54_);}\n\t.st50{clip-path:url(#SVGID_56_);fill:#D04090;}\n\t.st51{clip-path:url(#SVGID_58_);}\n\t.st52{clip-path:url(#SVGID_60_);fill:#00AABD;}\n\t.st53{clip-path:url(#SVGID_62_);}\n\t.st54{clip-path:url(#SVGID_64_);fill:#E1CE2B;}\n\t.st55{clip-path:url(#SVGID_66_);}\n\t.st56{clip-path:url(#SVGID_68_);fill:#006597;}\n\t.st57{clip-path:url(#SVGID_70_);}\n\t.st58{clip-path:url(#SVGID_72_);fill:#D04090;}\n\t.st59{clip-path:url(#SVGID_74_);}\n\t.st60{clip-path:url(#SVGID_76_);fill:#00AABD;}\n\t.st61{clip-path:url(#SVGID_78_);}\n\t.st62{clip-path:url(#SVGID_80_);fill:#E1CE2B;}\n\t.st63{fill:#1469A6;}\n\t.st64{fill:#E8D8AF;}\n\t.st65{fill:#F7F7F7;}\n\t.st66{fill:#FFDA2D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.9,45H7.1c-0.3,0-0.6-0.3-0.6-0.6v-1c0-0.3,0.3-0.6,0.6-0.6h9.8c0.3,0,0.6,0.3,0.6,0.6v1 C17.5,44.7,17.3,45,16.9,45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M16.9,42.8H7.1c-0.3,0-0.6-0.3-0.6-0.6v-1c0-0.3,0.3-0.6,0.6-0.6h9.8c0.3,0,0.6,0.3,0.6,0.6v1 C17.5,42.5,17.3,42.8,16.9,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M16.9,40.5H7.1c-0.3,0-0.6-0.3-0.6-0.6v-1c0-0.3,0.3-0.6,0.6-0.6h9.8c0.3,0,0.6,0.3,0.6,0.6v1 C17.5,40.3,17.3,40.5,16.9,40.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.5,38.3h9.8c0.3,0,0.6,0.3,0.6,0.6v1c0,0.3-0.3,0.6-0.6,0.6h-9.8c-0.3,0-0.6-0.3-0.6-0.6v-1 C19.9,38.6,20.2,38.3,20.5,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.5,33.8h9.8c0.3,0,0.6,0.3,0.6,0.6v1c0,0.3-0.3,0.6-0.6,0.6h-9.8c-0.3,0-0.6-0.3-0.6-0.6v-1 C19.9,34.1,20.2,33.8,20.5,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M20.5,40.5h9.8c0.3,0,0.6,0.3,0.6,0.6v1c0,0.3-0.3,0.6-0.6,0.6h-9.8c-0.3,0-0.6-0.3-0.6-0.6v-1 C19.9,40.8,20.2,40.5,20.5,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M20.5,31.6h9.8c0.3,0,0.6,0.3,0.6,0.6v1c0,0.3-0.3,0.6-0.6,0.6h-9.8c-0.3,0-0.6-0.3-0.6-0.6v-1 C19.9,31.9,20.2,31.6,20.5,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M20.5,42.8h9.8c0.3,0,0.6,0.3,0.6,0.6v1c0,0.3-0.3,0.6-0.6,0.6h-9.8c-0.3,0-0.6-0.3-0.6-0.6v-1 C19.9,43,20.2,42.8,20.5,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M20.5,36.1h9.8c0.3,0,0.6,0.3,0.6,0.6v1c0,0.3-0.3,0.6-0.6,0.6h-9.8c-0.3,0-0.6-0.3-0.6-0.6v-1 C19.9,36.3,20.2,36.1,20.5,36.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.8,38.3h-9.8c-0.3,0-0.6-0.3-0.6-0.6v-1c0-0.3,0.3-0.6,0.6-0.6h9.8c0.3,0,0.6,0.3,0.6,0.6v1 C44.4,38,44.1,38.3,43.8,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.8,31.6h-9.8c-0.3,0-0.6-0.3-0.6-0.6v-1c0-0.3,0.3-0.6,0.6-0.6h9.8c0.3,0,0.6,0.3,0.6,0.6v1 C44.4,31.3,44.1,31.6,43.8,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.8,42.8h-9.8c-0.3,0-0.6-0.3-0.6-0.6v-1c0-0.3,0.3-0.6,0.6-0.6h9.8c0.3,0,0.6,0.3,0.6,0.6v1 C44.4,42.5,44.1,42.8,43.8,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M43.8,36.1h-9.8c-0.3,0-0.6-0.3-0.6-0.6v-1c0-0.3,0.3-0.6,0.6-0.6h9.8c0.3,0,0.6,0.3,0.6,0.6v1 C44.4,35.8,44.1,36.1,43.8,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M43.8,29.3h-9.8c-0.3,0-0.6-0.3-0.6-0.6v-1c0-0.3,0.3-0.6,0.6-0.6h9.8c0.3,0,0.6,0.3,0.6,0.6v1 C44.4,29.1,44.1,29.3,43.8,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M43.8,45h-9.8c-0.3,0-0.6-0.3-0.6-0.6v-1c0-0.3,0.3-0.6,0.6-0.6h9.8c0.3,0,0.6,0.3,0.6,0.6v1 C44.4,44.7,44.1,45,43.8,45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M43.8,33.8h-9.8c-0.3,0-0.6-0.3-0.6-0.6v-1c0-0.3,0.3-0.6,0.6-0.6h9.8c0.3,0,0.6,0.3,0.6,0.6v1 C44.4,33.5,44.1,33.8,43.8,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M43.8,40.5h-9.8c-0.3,0-0.6-0.3-0.6-0.6v-1c0-0.3,0.3-0.6,0.6-0.6h9.8c0.3,0,0.6,0.3,0.6,0.6v1 C44.4,40.3,44.1,40.5,43.8,40.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 24.8,
    cy: 16.5,
    r: 9.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M28.4,20.3c-0.2,0.2-0.5,0.4-0.8,0.5c-0.3,0.1-0.6,0.2-0.9,0.2c-0.4,0-0.7-0.1-1.1-0.3 c-0.3-0.2-0.6-0.5-0.8-0.9c-0.6,0-1.1-0.1-1.6-0.4c-0.5-0.3-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.1,0.4-1.6 c0.3-0.5,0.7-0.8,1.2-1.1c0.5-0.3,1-0.4,1.6-0.4c0.6,0,1.1,0.1,1.6,0.4c0.5,0.3,0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6 c0,0.4-0.1,0.9-0.3,1.3c-0.2,0.4-0.4,0.7-0.7,1c-0.3,0.3-0.7,0.5-1.1,0.6c0.3,0.3,0.6,0.5,0.9,0.5c0.3,0,0.7-0.2,1.1-0.5 L28.4,20.3z M23.1,17.6c0.2,0.3,0.4,0.6,0.7,0.7c0.3,0.2,0.7,0.3,1,0.3c0.4,0,0.7-0.1,1-0.3s0.6-0.4,0.7-0.7 c0.2-0.3,0.3-0.7,0.3-1s-0.1-0.7-0.3-1c-0.2-0.3-0.4-0.6-0.7-0.7c-0.3-0.2-0.6-0.3-1-0.3c-0.4,0-0.7,0.1-1,0.3 c-0.3,0.2-0.6,0.4-0.7,0.7c-0.2,0.3-0.3,0.7-0.3,1S22.9,17.3,23.1,17.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M44.1,8c-0.2-0.2-0.5-0.3-0.8-0.3l-3.1,0.5c-0.5,0.1-0.9,0.6-0.8,1.1c0.1,0.5,0.6,0.9,1.1,0.8l0.1,0l-4,4 c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.4,0.3,0.7,0.3c0.2,0,0.5-0.1,0.7-0.3l4.1-4.1L42,11.7c-0.1,0.5,0.3,1,0.8,1.1 c0.3,0,0.5,0,0.7-0.2c0.2-0.2,0.3-0.4,0.4-0.6l0.5-3.2C44.4,8.5,44.3,8.2,44.1,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M12.6,19.4L9.4,20c-0.3,0-0.5,0.2-0.6,0.4c-0.1,0.2-0.2,0.5-0.2,0.7c0.1,0.5,0.6,0.9,1.1,0.8l0.1,0l-4,4 c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.4,0.3,0.7,0.3c0.2,0,0.5-0.1,0.7-0.3l4.1-4.1l-0.1,0.4c0,0.3,0,0.5,0.2,0.7 c0.2,0.2,0.4,0.3,0.6,0.4c0.3,0,0.5,0,0.7-0.2c0.2-0.2,0.3-0.4,0.4-0.6l0.5-3.2c0-0.3-0.1-0.6-0.3-0.8 C13.2,19.5,12.9,19.4,12.6,19.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M98,147.9c-0.7,1.9-2.5,3.2-4.7,3.2c-2.8,0-5.2-2.3-5.1-5.1c0.1-3.1,2.4-5.1,5.1-5.1c2.1,0,4,1.3,4.7,3.2 c0.5-0.8,1.3-1.3,2.2-1.6c-1.3-2.5-3.9-4.3-6.9-4.3c-4.3,0-7.8,3.5-7.8,7.7c0,4.3,3.5,7.8,7.8,7.8c3,0,5.7-1.8,7-4.3 C99.3,149.2,98.5,148.6,98,147.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: -403.4,
    y: 43.3,
    width: 734.9,
    height: 445.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M103.8,146c0,1.3-1.1,2.3-2.4,2.3c-1.3,0-2.3-1.1-2.3-2.4c0-1.3,1.1-2.3,2.4-2.3 C102.7,143.6,103.8,144.7,103.8,146"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: -403.4,
    y: 43.3,
    width: 734.9,
    height: 445.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M95.8,145.9c0,1.3-1.1,2.3-2.4,2.3c-1.3,0-2.3-1.1-2.3-2.4c0-1.3,1.1-2.3,2.4-2.3 C94.8,143.6,95.8,144.7,95.8,145.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: -403.4,
    y: 43.3,
    width: 734.9,
    height: 445.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_29_",
    d: "M97.8,146.1c0.4,0.9,0.8,1.8,1.1,2l0,0l0,0c0.6,0.7,1.5,1.1,2.5,1.1c0.9,0,1.7-0.3,2.4-1 c0.6-0.6,1-1.5,1-2.4c0-0.9-0.3-1.7-1-2.4c-0.6-0.6-1.5-1-2.4-1c-1.4,0-2.7,0.9-3.2,2.3v0C98.2,145,98,145.5,97.8,146.1  M94.1,142.7c-0.2,0-0.4-0.1-0.6-0.1c-1.8,0-3.4,1.5-3.4,3.3c0,0.9,0.3,1.7,1,2.4c0.6,0.6,1.5,1,2.4,1c0.9,0,1.8-0.4,2.5-1.1 l0.1-0.1c0.3-0.2,0.7-1.1,1.1-2c-0.2-0.6-0.4-1.1-0.5-1.2l0-0.1C96.2,143.7,95.3,142.9,94.1,142.7 M92.7,149.9 c-1.8-0.4-3.2-2-3.2-3.9c0-2.2,1.8-4,4-4c1.7,0,3.2,1.1,3.7,2.7l0,0c0.1,0.2,0.1,0.4,0.2,0.6c0.1-0.2,0.2-0.4,0.2-0.6v0 c0.6-1.6,2.1-2.7,3.8-2.7c1.1,0,2.1,0.4,2.8,1.2c0.8,0.8,1.2,1.7,1.2,2.8s-0.4,2.1-1.2,2.8c-0.8,0.8-1.7,1.2-2.8,1.2 c-1.1,0-2.2-0.5-2.9-1.3l0,0c-0.3-0.3-0.7-1-1-1.7c-0.3,0.7-0.7,1.4-1,1.7l0,0c-0.8,0.8-1.8,1.3-3,1.3 C93.2,149.9,93,149.9,92.7,149.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: -403.4,
    y: 43.3,
    width: 734.9,
    height: 445.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_49_",
    d: "M100-111c-1.4,3.6-4.9,6.1-9.1,6.2c-5.4,0-10.1-4.4-9.9-9.8c0.1-6,4.7-9.8,9.9-9.9 c4.1-0.1,7.7,2.5,9.2,6.1c1-1.5,2.5-2.6,4.3-3.1c-2.5-4.9-7.6-8.2-13.4-8.2c-8.3,0-15,6.7-15.1,15c0,8.4,6.8,15.2,15.1,15.2 c5.8,0,11-3.4,13.5-8.3C102.5-108.4,101-109.5,100-111"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st31"
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_51_",
    x: -870.4,
    y: -313.4,
    width: 1422.3,
    height: 862.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_53_",
    d: "M111.1-114.7c0,2.5-2.1,4.5-4.6,4.5c-2.5,0-4.5-2.1-4.5-4.6c0-2.5,2.1-4.5,4.6-4.5 C109.1-119.2,111.1-117.2,111.1-114.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st33"
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_55_",
    x: -870.4,
    y: -313.4,
    width: 1422.3,
    height: 862.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_57_",
    d: "M95.7-114.7c0,2.5-2.1,4.5-4.6,4.5s-4.5-2.1-4.5-4.6s2.1-4.5,4.6-4.5C93.7-119.3,95.7-117.2,95.7-114.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st35"
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_59_",
    x: -870.4,
    y: -313.4,
    width: 1422.3,
    height: 862.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_59_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_61_",
    d: "M99.5-114.4c0.7,1.8,1.6,3.4,2.1,4l0.1,0.1l0,0.1c1.2,1.4,3,2.2,4.8,2.2c1.7,0,3.3-0.7,4.6-1.9 c1.2-1.2,1.9-2.8,1.9-4.6c0-1.7-0.7-3.3-1.9-4.6c-1.2-1.2-2.8-1.9-4.6-1.9c-2.8,0-5.2,1.8-6.1,4.4v0 C100.4-116.5,100-115.5,99.5-114.4 M92.4-121c-0.4-0.1-0.8-0.1-1.2-0.1c-3.6,0-6.5,2.9-6.5,6.4c0,1.7,0.7,3.3,1.9,4.6 c1.2,1.2,2.8,1.9,4.6,1.9c1.8,0,3.6-0.8,4.8-2.1l0.1-0.1c0.5-0.5,1.4-2.2,2.2-4c-0.5-1.1-0.8-2.1-0.9-2.3l0-0.1 C96.5-119,94.7-120.6,92.4-121 M89.7-107.2c-3.5-0.7-6.2-3.8-6.2-7.5c0-4.2,3.5-7.7,7.7-7.7c3.2,0,6.2,2.1,7.2,5.2l0,0.1 c0.1,0.3,0.3,0.7,0.4,1.1c0.2-0.4,0.3-0.8,0.4-1.1v0c1.1-3.1,4-5.2,7.3-5.2c2.1,0,4,0.8,5.4,2.3c1.5,1.5,2.2,3.4,2.2,5.4 c0,2.1-0.8,4-2.3,5.4c-1.5,1.5-3.4,2.2-5.4,2.2c-2.2,0-4.3-0.9-5.7-2.6l0,0c-0.6-0.6-1.3-1.9-2-3.3c-0.6,1.4-1.4,2.7-2,3.3l0,0 c-1.5,1.6-3.5,2.5-5.7,2.5C90.6-107,90.2-107,89.7-107.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_61_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st37"
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_63_",
    x: -870.4,
    y: -313.4,
    width: 1422.3,
    height: 862.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_63_",
    style: {
      overflow: "visible"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSales);
export default __webpack_public_path__ + "static/media/icon-sales.4d8abffed5f6fff0b12b5178cf8b6cb2.svg";
export { ForwardRef as ReactComponent };